import { render, staticRenderFns } from "./SignUpBlocksList.vue?vue&type=template&id=482149aa"
import script from "./SignUpBlocksList.vue?vue&type=script&lang=js"
export * from "./SignUpBlocksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports